<template>
  <div>
    <div class="inner-header ">
      <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
        <a @click="$router.go(-1)" class="back-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
            <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
              <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2" />
              <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
            </g>
          </svg>
        </a>
        <a href="javascript:void(0);" class="link-title">Edit Broker</a>
      </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="row">
          <!-- Enquiry Card -->
          <div class="col-12">
            <div class="card details-card form-card">
              <div class="card-body p-0 mt-4">
                <div class="row">
                  <div class="col-12">
                    <b-form @submit.prevent="UpdateBrokerDetails">
                      <b-form-group>
                        <label>NCD<span class="text-danger">*</span></label>
                        <datetime type="datetime" v-model="UpdateBroker.next_call_date" required placeholder="Next Call Date And Time">
                        </datetime>
                      </b-form-group>
                      <b-form-group>
                        <label>Status<span class="text-danger">*</span></label>
                        <b-form-select v-model="UpdateBroker.status_id" required @input="checkValidation(UpdateBroker.status_id,'status_id')" :options="statusList"></b-form-select>
                      </b-form-group>
                      <b-form-group>
                        <label>Sub Status</label>
                        <b-form-select v-model="UpdateBroker.sub_status_id"  :options="subStatusList"></b-form-select>
                      </b-form-group>
                      <b-form-group>
                        <label>Performance<span class="text-danger">*</span></label>
                        <b-form-select v-model="UpdateBroker.performance" @input="checkValidation(UpdateBroker.performance,'performance')"  required :options="performanceList"></b-form-select>
                      </b-form-group>
                      <b-form-group v-if="isSuperAdmin">
                        <label>Calling Executive<span class="text-danger">*</span></label>
                        <b-form-select v-model="UpdateBroker.calling_executive_id" required :options="callingExecutives" @input="checkValidation(UpdateBroker.calling_executive_id,'calling_executive_id')"></b-form-select>
                      </b-form-group>
                      <b-form-group v-if="isSourcing">
                        <label>Meeting Done<span class="text-danger">*</span></label>
                        <datetime type="date" v-model="UpdateBroker.meeting_done" required placeholder="Meeting Done">
                        </datetime>
                      </b-form-group>
                      <b-form-group v-if="!isSourcing">
                        <label>Meeting Scheduled<span class="text-danger">*</span></label>
                        <datetime type="date" v-model="UpdateBroker.meeting_scheduled" required placeholder="Meeting Scheduled">
                        </datetime>
                      </b-form-group>
                      <b-form-group>
                        <label>Comment<span class="text-danger">*</span></label>
                        <div v-html="UpdateBroker.comment"></div>
                        <b-form-textarea placeholder="Add Comment" v-model="UpdateBroker.executive_comments" required rows="3" max-rows="5"></b-form-textarea>
                      </b-form-group>
                      <b-form-group class="mt-2">
                        <b-button variant="primary" type="submit" block>Save</b-button>
                      </b-form-group>
                    </b-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CATEGORIZATION_CAN_CHANGE_IDS } from '@/assets/scripts/utility.js';
import { Datetime } from 'vue-datetime';
export default {
  name: 'EditCPBroker',
  components: {
    datetime: Datetime
  },
  data() {
    return {
      UpdateBroker: {},
      brokerDetails:{},
      queryP: {},
    }
  },
  computed: {
    cpSettings() {
      return this.$store.getters.cpSettings;
    },
    statusList() {
      return this.$store.getters.cpSettings && (localStorage.getItem('radiate-user-sourcing') === 'true' ? this.$store.getters.cpSettings.sourcing_crm_statuses : this.$store.getters.cpSettings.non_sourcing_crm_statuses);
    },
    subStatusList() {
      let filter_data = this.$store.getters.cpSettings.sub_status_data.filter(f => f.status_id == this.UpdateBroker.status_id);
      return filter_data.map(({ id, name }) => ({ value: id,text: name}));

    },
    performanceList() {
      return this.$store.getters.cpSettings && this.$store.getters.cpSettings.performance;
    },
    isSuperAdmin() {
      return Number(localStorage.getItem('radiate-crm-role_id')) === 1;
    },
    isSourcing(){
      localStorage.getItem('radiate-user-sourcing') === 'true';
    },
    categorizationList(){
       return this.$store.getters.cpSettings && (this.brokerDetails.categorization && CATEGORIZATION_CAN_CHANGE_IDS.includes(this.brokerDetails.categorization) && localStorage.getItem('radiate-user-sourcing') === 'true'? this.$store.getters.cpSettings.categorization_can_change : this.$store.getters.cpSettings.categorization);
    },
    callingExecutives(){
      return this.$store.getters.cpSettings && this.$store.getters.cpSettings.calling_executives;
    }
  },
  created() {
    this.GetBrokerDetails(this.$route.params.brokerid);
  },
  mounted(){
    if(!this.cpSettings || Object.keys(this.cpSettings).length === 0){
      this.fetchMyCPSettings();
    }
  },
  methods: {
    GetBrokerDetails(id) {
      this.queryP['broker_id'] = this.$route.params.brokerid;
      this.$axios.get(`brokers/${this.queryP.broker_id}/my_cps_detail`).then((res) => {
        this.brokerDetails = res && res.data && res.data.broker;
        this.UpdateBroker = this.brokerDetails;
        if(this.brokerDetails.comment){
          this.UpdateBroker.comment = this.brokerDetails.comment.replaceAll('\n', '<br>');
        }
      }).catch(err => console.log(err));
    },
    checkValidation(row,key){
      if(!row){
        this.UpdateBroker[key] = null;
      }
    },
    fetchMyCPSettings(){
              this.$axios.get('brokers/my_cps_settings')
      .then(res => {
        this.settingsList = res.data;
        if(this.settingsList){
          if(this.settingsList && this.settingsList.sourcing_crm_statuses){
            this.settingsList.sourcing_crm_statuses = this.settingsList.sourcing_crm_statuses.map(status=>({...status,text:status.name,value:status.id}));
            this.settingsList.sourcing_crm_statuses.unshift({text:'Select Status', value:''});
          }
          if(this.settingsList && this.settingsList.non_sourcing_crm_statuses){
            this.settingsList.non_sourcing_crm_statuses = this.settingsList.non_sourcing_crm_statuses.map(status=>({...status,text:status.name,value:status.id}));
            this.settingsList.non_sourcing_crm_statuses.unshift({text:'Select Status', value:''});
          }
          if(this.settingsList && this.settingsList.localities){
            this.settingsList.localities = this.settingsList.localities.map(locality=>({...locality,text:locality.name,value:locality.id}));
            this.settingsList.localities.unshift({name:'Select Localities', id:''});
          }
          if(this.settingsList && this.settingsList.performance){
            this.settingsList.performance = this.settingsList.performance.map(perf=>({text:perf, value:perf}));
            this.settingsList.performance.unshift({text:'Select Performance', value:''});
          }
          if(this.settingsList && this.settingsList.categorization){
            this.settingsList.categorization = this.settingsList.categorization.map(category=>({text:category, value:category}));
            this.settingsList.categorization.unshift({text:'Select Categorization', value:''});
          }
          if(this.settingsList && this.settingsList.categorization_can_change){
            this.settingsList.categorization_can_change = this.settingsList.categorization_can_change.map(category=>({text:category, value:category}));
            this.settingsList.categorization_can_change.unshift({text:'Select Categorization', value:''});
          }
           if(this.settingsList && this.settingsList.field_executives){
            this.settingsList.field_executives = this.settingsList.field_executives.map(executive=>({...executive,text:executive.full_name, value:executive.id}));
            this.settingsList.field_executives.unshift({text:'Select Executive', value:''});
          }
          if(this.settingsList && this.settingsList.calling_executives){
            this.settingsList.calling_executives = this.settingsList.calling_executives.map(executive=>({...executive,text:executive.full_name, value:executive.id}));
            this.settingsList.calling_executives.unshift({text:'Select Executive', value:''});
          }
          if(this.settingsList && this.settingsList.tls){
            this.settingsList.tls = this.settingsList.tls.map(executive=>({...executive,text:executive.full_name, value:executive.id}));
            this.settingsList.tls.unshift({text:'Select TL', value:''});
          }
          if(this.settingsList && this.settingsList.cities){
            this.settingsList.cities = this.settingsList.cities.map(city=>({...city,text:city.name, value:city.id}));
            this.settingsList.cities.unshift({text:'Select City', value:''});
          }
          if(this.settingsList && this.settingsList.kyc_statuses){
            this.settingsList.kyc_statuses = Object.keys(res.data.kyc_statuses).map(kyc=>({text:kyc, value:res.data.kyc_statuses[kyc]}));
            this.settingsList.kyc_statuses.unshift({text:'Select KYC Status', value:''});
          }
        }
        this.$store.dispatch('setCPSettings',res.data);
      }).catch(err=>console.log(err.response));
    },
    UpdateBrokerDetails() {
      let apiParams = this.UpdateBroker;
      this.$axios
        .put(`brokers/${this.queryP.broker_id}`, { ...apiParams })
        .then((res) => {
          swal({
            title: "Broker Updated!",
            icon: "success",
          }).then(this.$router.replace({ name: "CPBrokerDetails", params: { brokerid: this.brokerDetails.id } }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
  }
}
</script>